export function replacePlaceholders(message: string, values: any) {
    let result = message;
    for (const [placeholder, value] of Object.entries(values)) {
        result = result.replace(new RegExp(placeholder, 'g'), value as string);
    }
    return result;
}